/** Dependency-free browser helper. No API requests or automatic sends. */
export const DISCOVERY_EMAIL_SUBJECT = 'Your Creative Mojo Discovery Portal';

export function buildDiscoveryPortalEmail({ email, firstName, portalUrl }) {
  const url = String(portalUrl ?? '').trim();
  let parsed;
  try { parsed = new URL(url); } catch { throw new Error('A valid Discovery Portal URL is required.'); }
  if (!['https:', 'http:'].includes(parsed.protocol)) {
    throw new Error('A valid Discovery Portal URL is required.');
  }

  const name = String(firstName ?? '').replace(/[\r\n]+/g, ' ').trim();
  const body = [
    name ? `Hi ${name},` : 'Hi there,',
    'Here is a link to our online Discovery Portal that brings together the information you need to explore the opportunity further.',
    'You can use it to view your potential territory, read a copy of the franchise agreement, and find details of any shadow or training days that may be booked in.',
    `Visit your Discovery Portal:\r\n${url}`,
    'Password: MojoDiscovery',
    'If you do decide Mojo is the right fit for you, this page will then become your Launch Portal, providing all the extra setup tools and areas for you to enter the info we need from you to get your franchise up and running.',
    'If you have any questions while looking through it, just come back to me.',
  ].join('\r\n\r\n');

  const recipient = String(email ?? '').trim();
  const result = { subject: DISCOVERY_EMAIL_SUBJECT, body, portalUrl: url, recipient, mailtoHref: null, warning: null };
  if (!recipient) {
    result.warning = 'Discovery Portal link is ready. Add an email address to this contact to open an email draft.';
    return result;
  }
  // One bare email address; reject header/query injection and recipient lists.
  if (!/^[^\s<>;,?&#@]+@[^\s<>;,?&#@]+\.[^\s<>;,?&#@]+$/.test(recipient)) {
    result.warning = 'Discovery Portal link is ready. Check this contact’s email address to open an email draft.';
    return result;
  }

  result.mailtoHref = `mailto:${encodeURIComponent(recipient)}?subject=${encodeURIComponent(result.subject)}&body=${encodeURIComponent(body)}`;
  return result;
}

/** Requests the OS email handler; browsers cannot confirm that a draft opened. */
export function openDiscoveryPortalEmail(draft, navigate = (href) => window.location.assign(href)) {
  if (!draft?.mailtoHref) return false;
  navigate(draft.mailtoHref);
  return true;
}
